export default "__VITE_PUBLIC_ASSET__1d322a3e__"